import { render, staticRenderFns } from "./msg402.vue?vue&type=template&id=2dd4f458&"
import script from "./msg402.vue?vue&type=script&lang=js&"
export * from "./msg402.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports